// extracted by mini-css-extract-plugin
export default {"drop-zone":"tnLRBxwT","dropZone":"tnLRBxwT","dragging":"emmu11tq","input":"cJPulpj9"};